const LoadingSkeleton = () => {
	return (
		<div className="grid gap-4 grid-cols-12 mt-8 md:mt-14">
			<div className="col-span-12 flex flex-col">
				<div className="text-sm font-semibold mb-3 hidden md:block">Current plan</div>
				<div className="bg-white border border-[#F2F2F2] rounded-xl py-4 md:py-4 px-4 md:px-5 flex-grow flex flex-col items-start min-h-[200px]">
					<div className="text-[13px] font-semibold mb-6 block md:hidden">Current plan</div>
					<div className="flex flex-row items-start w-full mb-7">
						<h2 className="h2 mb-0">
							<div className="animate-pulse bg-[#F2F2F2] rounded-full w-32 h-4 sm:h-3 sm:mt-1.5 inline-block" />
						</h2>
						<div className="badge px-2.5 text-[#A3A8A9] mt-0 md:mt-1 ml-auto shrink-0">
							<div className="animate-pulse bg-[#F2F2F2] rounded-full w-24 h-4 sm:h-3 sm:mt-1.5 inline-block" />
						</div>
					</div>
					<div className="flex flex-wrap gap-x-10 gap-y-5">
						<div>
							<div className="text-[11px] md:text-[13px]/[1.2] text-[#A5A5A5] font-medium mb-2">
								<div className="animate-pulse bg-[#F2F2F2] rounded-full w-24 h-4 sm:h-3 sm:mt-1.5 inline-block" />
							</div>
							<div>
								<div className="animate-pulse bg-[#F2F2F2] rounded-full w-32 h-4 sm:h-3 sm:mt-1.5 inline-block" />
							</div>
						</div>
						<div>
							<div className="text-[11px] md:text-[13px]/[1.2] text-[#A5A5A5] font-medium mb-2">
								<div className="animate-pulse bg-[#F2F2F2] rounded-full w-24 h-4 sm:h-3 sm:mt-1.5 inline-block" />
							</div>
							<div className="text-sm md:text-base">
								<div className="animate-pulse bg-[#F2F2F2] rounded-full w-14 h-4 sm:h-3 sm:mt-1.5 inline-block" />
							</div>
						</div>
						<div>
							<div className="text-[11px] md:text-[13px]/[1.2] text-[#A5A5A5] font-medium mb-2">
								<div className="animate-pulse bg-[#F2F2F2] rounded-full w-20 h-4 sm:h-3 sm:mt-1.5 inline-block" />
							</div>
							<div className="text-sm md:text-base">
								<div className="animate-pulse bg-[#F2F2F2] rounded-full w-24 h-4 sm:h-3 sm:mt-1.5 inline-block" />
							</div>
						</div>
					</div>
					<div className="animate-pulse bg-[#F2F2F2] rounded-full w-full sm:w-40 h-4 sm:h-3 inline-block mt-10 mb-3" />
				</div>
			</div>
			<div className="col-span-12 flex flex-col">
				<div className="text-sm font-semibold mb-3 hidden md:block">Payment method</div>
				<div className="bg-white border border-[#F2F2F2] rounded-xl py-4 md:py-4 px-4 md:px-5 flex-grow flex flex-col items-start min-h-[200px]">
					<div className="text-[13px] font-semibold mb-6 block md:hidden">Payment method</div>
					<div className="flex flex-col text-[13px] md:text-base max-w-full">
						<div className="animate-pulse bg-[#F2F2F2] rounded-full w-72 max-w-full h-4 sm:h-3 mt-1.5 inline-block" />
						<div className="animate-pulse bg-[#F2F2F2] rounded-full w-56 max-w-full h-4 sm:h-3 mt-1.5 inline-block" />
						<div className="animate-pulse bg-[#F2F2F2] rounded-full w-28 h-4 sm:h-3 mt-1.5 inline-block" />
					</div>
					<div className="animate-pulse bg-[#F2F2F2] rounded-full w-full sm:w-40 h-4 sm:h-3 inline-block mt-8 md:mt-auto mb-2" />
				</div>
			</div>
		</div>
	);
}

export default LoadingSkeleton;
